<template>
<div>
  <template v-if="$route.name === 'EXCMRelationCategoryCreate'">
    <b-row>
      <b-col>
        <router-link :to="{ name: 'EXCMRelationCategoryList' }" class="mb-1 btn btn-sm btn-default float-right">{{ $t('buttons.backToList') }}</router-link>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="card">
          <div class="card-body">
            <b-row>
              <b-col>
                <Form
                  :handle-submit="onSendForm"
                  :values="item"
                  :violations="violations"/>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-col>
    </b-row>
  </template>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Form from './Form'

export default {
  name: 'Create',
  components: {
    Form
  },
  data () {
    return {
      item: {
        title: '',
        accessType: 0,
        rolesToViewAllowed: []
      }
    }
  },
  watch: {
    created (val) {
      if (val) this.$router.push({ name: 'EXCMRelationCategoryList' })
    }
  },
  beforeDestroy () {
    this.reset()
  },
  computed: {
    ...mapGetters({
      created: 'excmrelationcategory/create/created',
      violations: 'excmrelationcategory/create/violations',
      isLoading: 'excmrelationcategory/create/isLoading'
    })
  },
  methods: {
    onSendForm () {
      this.create(this.item)
    },
    ...mapActions({
      create: 'excmrelationcategory/create/create',
      reset: 'excmrelationcategory/create/reset'
    })
  }
}
</script>

<style scoped>

</style>
